import React from 'react';
import PropTypes from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import {
  LayoutGroup,
  LayoutManager,
} from '@thd-olt-component-react/layout-manager';

import { GuestHomepage } from './GuestHomepage';

export const GuestHomepageContainer = ({ slug }) => {
  return (
    <QueryProvider cacheKey="consumer-homepage">
      <LayoutManager name="my-homepage-wrapper">
        <LayoutGroup name="my-homepage-content">
          <GuestHomepage slug={slug} />
        </LayoutGroup>
      </LayoutManager>
    </QueryProvider>
  );
};

GuestHomepageContainer.propTypes = {
  slug: PropTypes.string,
};

GuestHomepageContainer.defaultProps = {
  slug: undefined,
};
